import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["checked"]
const _hoisted_2 = {
  key: 0,
  class: "toggle-button__label"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ToggleButton',
  props: {
    value: { type: Boolean },
    type: { default: 'toggle' }
  },
  emits: ['update:value'],
  setup(__props: any, { emit: __emit }) {



const emit = __emit

function notifyChange(event: Event): void {
  // This event must match the name of the `value` prop
  // so that `v-model` can be used.
  emit('update:value', (event.target as HTMLInputElement)?.checked)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", {
    class: _normalizeClass(["toggle-button", `toggle-button--${__props.type}`])
  }, [
    _createElementVNode("input", {
      class: "toggle-button__input",
      type: "checkbox",
      checked: __props.value,
      onChange: notifyChange
    }, null, 40, _hoisted_1),
    _cache[0] || (_cache[0] = _createElementVNode("span", { class: "toggle-button__slider" }, null, -1)),
    (_ctx.$slots.default || __props.type === 'checkbox')
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          _renderSlot(_ctx.$slots, "default")
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})